import { createSlice } from "@reduxjs/toolkit";

export const campusSlice = createSlice({
  name: "campus",
  initialState: {
    list: [],
  },
  reducers: {
    setCampus: (state, action) => {
      console.log("setCampus", action.payload);
      state.list = action.payload.list;
    },
  },
});

export const { setCampus } = campusSlice.actions;

export default campusSlice.reducer;
